export default {
  error (error) {
    if (window.webpackHotUpdate || sessionStorage.getItem('debug')) console.error(error)
  }
}
